<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [canGoBack]="false"
    [title]="'Campaigns'" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (loaded) {
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'Set up your campaigns.'" />
      </tidy-row>
      <tidy-row>
        <tidy-table
          [dataSource]="rows"
          [displayedColumns]="headers"
          [columnslabels]="headers" />
      </tidy-row>
      <tidy-button
        [text]="'New Campaign'"
        [action]="boundNewCampaign"
        class="primary" />
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'Talk to your account manager about starting a new campaign.'" />
      </tidy-row>
    }
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content" [desktopWidthContent]="desktopWidthContent" />
